
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/genres",
      function () {
        return require("private-next-pages/d/genres.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/genres"])
      });
    }
  